export default "__VITE_ASSET__DgNxG3up__"